<template>
  <el-dialog title="导入"
             :visible.sync="dialogVisible"
             :show-close="false"
             custom-class="importDialog"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form"
             :rules="rules"
             ref="refDialog"
             label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label-width
                        prop="profession1"
                        label="行业1">
            <el-select filterable
                       allow-create
                       clearable
                       default-first-option
                       v-model="form.profession1"
                       placeholder="请选择"
                       ref="profession1"
                       @blur="selectBlur"
                       @focus="selectFocus('profession1')"
                       style="width: 90%">
              <el-option v-for="item in maijiaProfession.maijiaProfession1"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width
                        prop="profession2"
                        label="行业2">
            <el-select filterable
                       allow-create
                       clearable
                       default-first-option
                       v-model="form.profession2"
                       placeholder="请选择"
                       ref="profession2"
                       @blur="selectBlur"
                       @focus="selectFocus('profession2')"
                       style="width: 90%">
              <el-option v-for="item in maijiaProfession.maijiaProfession2"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width
                        prop="profession3"
                        label="行业3">
            <el-select filterable
                       allow-create
                       clearable
                       default-first-option
                       v-model="form.profession3"
                       placeholder="请选择"
                       ref="profession3"
                       @blur="selectBlur"
                       @focus="selectFocus('profession3')"
                       style="width: 90%">
              <el-option v-for="item in maijiaProfession.maijiaProfession3"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width
                        prop="profession4"
                        label="行业4">
            <el-select filterable
                       allow-create
                       clearable
                       default-first-option
                       v-model="form.profession4"
                       placeholder="请选择"
                       ref="profession4"
                       @blur="selectBlur"
                       @focus="selectFocus('profession4')"
                       style="width: 90%">
              <el-option v-for="item in maijiaProfession.maijiaProfession4"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width
                        prop="profession5"
                        label="行业5">
            <el-select filterable
                       allow-create
                       clearable
                       default-first-option
                       v-model="form.profession5"
                       placeholder="请选择"
                       ref="profession5"
                       @blur="selectBlur"
                       @focus="selectFocus('profession5')"
                       style="width: 90%">
              <el-option v-for="item in maijiaProfession.maijiaProfession5"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width
                        prop="profession6"
                        label="行业6">
            <el-select filterable
                       allow-create
                       clearable
                       default-first-option
                       v-model="form.profession6"
                       placeholder="请选择"
                       ref="profession6"
                       @blur="selectBlur"
                       @focus="selectFocus('profession6')"
                       style="width: 90%">
              <el-option v-for="item in maijiaProfession.maijiaProfession6"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="时间"
                    prop="create_time">
        <el-date-picker v-model="form.create_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="下载时间"
                    prop="download_time">
        <!-- <el-input v-model="form.download_time"></el-input> -->
        <el-date-picker v-model="form.download_time"
                        :picker-options="pickerOptions"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"></el-date-picker>
      </el-form-item>
      <el-row style="margin: 10px 20px;">
        <span>当前下载时间：{{time}}</span>
      </el-row>
      <el-form-item label="文件"
                    required>
        <el-upload :on-remove="handleRemove"
                   class="upload-demo"
                   drag
                   action="fake"
                   accept=".xlsx, .xls, .csv"
                   :limit="1"
                   :auto-upload="false"
                   :on-change="handleChange"
                   ref="refUpload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <!-- <div class="el-upload__trigger" slot="trigger">只能上传 xlsx文件，且不超过 3M</div> -->
          <div class="el-upload__tip"
               slot="tip">只能上传 xlsx xls csv文件，且不超过 30M</div>
          <div class="el-upload__tip"
               slot="tip">
            <el-col :span="12">
              <el-form-item label-width="0px">
                <el-button type="primary"
                           icon="el-icon-document"
                           @click="downloadTemp">点击下载模板文件</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resolvingXLSX } from '@/utils'
export default {
  name: 'ImportDialogSimple',
  data() {
    return {
      dialogVisible: false,
      rules: {
        download_time: [{ required: true, message: '必填项', trigger: 'blur' }],
        create_time: [{ required: true, message: '必填项', trigger: 'blur' }],
        profession1: [{ required: true, message: '必填项', trigger: 'blur' }],
        profession2: [{ required: true, message: '必填项', trigger: 'blur' }],
        profession3: [{ required: false, message: '必填项', trigger: 'blur' }],
        profession4: [{ required: false, message: '必填项', trigger: 'blur' }],
        profession5: [{ required: false, message: '必填项', trigger: 'blur' }],
        profession6: [{ required: false, message: '必填项', trigger: 'blur' }],
      },
      form: {
        profession1: '',
        profession2: '',
        profession3: '',
        profession4: '',
        profession5: '',
        profession6: '',
      },
      file: null,
      time: '',
      formworkFile: '',
      maijiaProfession: [],
      pickerOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
      selFid: '',
    }
  },
  created() {
    // this.getTableData();
    this.getImportTemp()
  },
  methods: {
    selectBlur(e) {
      let value = e.target.value
      setTimeout(() => {
        if(value){
          this.$refs[this.selFid].$children[0].$refs.input.value = value
        }
      }, 100)
    },
    selectFocus(e) {
      setTimeout(() => {
        this.selFid = e
      }, 200)
    },
    async getImportTemp() {
      console.log('xxxxx')
      // this.loading = true
      let name = this.$route.meta.routeName.split('.')[1]
      console.log(name)
      let { data, err } = await this.axiosApi({
        url: `getFormworkFile/${name}`,
      })
      if (data && data.data.meta.status === 200) {
        console.log('data', data.data.data)
        this.formworkFile = data.data.data
      }
    },
    downloadTemp() {
      if (this.formworkFile) {
        window.location.href = this.formworkFile
      }
    },
    show(time, list) {
      console.log(list)
      this.time = time
      this.maijiaProfession = list
      this.dialogVisible = true
    },
    hide() {
      // debugger;
      this.dialogVisible = false
      this.file = null
      this.form = {}
      // resetField clearValidate
      this.$refs.refDialog.resetFields()
      this.$refs.refUpload.clearFiles()
    },
    handleRemove(file, fileList) {
      console.log('file, fileList', file, fileList)
      this.file = null
    },
    handleChange(file, fileList) {
      console.log('handleChange file', file)
      let list = file.name.split('.')
      let suffix = list[list.length - 1]
      let arr = ['xlsx', 'xls', 'csv']
      if (!arr.includes(suffix)) {
        this.$refs.refUpload.clearFiles()
        this.$message.error('导入模板有误，请检查导入文件格式')
      } else {
        this.file = file.raw
      }
    },
    async submit() {
      let isValid
      this.$refs.refDialog.validate((valid) => {
        isValid = valid
      })
      if (!isValid) {
        return
      }

      if (!this.file) {
        this.$message.error({
          message: '请添加文件',
          // offset: 61,
        })
        return
      }
      // 已有比当前下载时间晚的时间存在，是否继续导入以覆盖数据
      if (this.file.size > 30 * 1024 ** 2) {
        this.$message.error({
          message: '文件大小不能超过 30M',
          // offset: 61,
        })
        return
      }

      // 校验下载时间
      let isLast = true
      // debugger;
      let sysTime = new Date(this.time).getTime()
      let formTime = new Date(this.form.download_time).getTime()
      console.log('sysTime > formTime', sysTime > formTime)
      if (sysTime > formTime) {
        isLast = false
      }

      if (isLast) {
        // 不校验 导入文件
        // reportname 当前页面的URL
        console.log('this.$route', this.$route)
        this.form.file = this.file
        this.form.reportname = this.$route.path.replace('/', '')
        this.$emit('submit', this.form)
        this.hide()
      } else {
        this.$confirm(
          '已有比当前下载时间晚的时间存在，是否继续导入以覆盖数据?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            console.log('this.$route', this.$route)
            this.form.file = this.file
            this.form.reportname = this.$route.path.replace('/', '')
            this.$emit('submit', this.form)
            this.hide()
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 600px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/maijia/maijia-professionprice/import-dialog.vue